<!--加工单入仓 -->
<template>
    <div class="warehouseOut" v-loading="dailogLoading">
        <div class="dialog-header">
            <div>
                <el-button v-if="!isTcrkModel" class="btn-primary" size="small" @click="isTcrkModel = true">同仓入库</el-button>
                <el-select
                    v-if="isTcrkModel"
                    v-model="tcrkWarehouseId"
                    size="small"
                    filterable
                    clearable
                    style="margin-right: 20px"
                    @change="
                        val => {
                            (tcrkShelfSpaceId = ''), (tcrkShelfSpaceOptions = []);
                        }
                    "
                >
                    <el-option v-for="optionItem in WarehouseList" :label="optionItem.WarehouseName" :value="optionItem.WarehouseId" :key="optionItem.WarehouseId"> </el-option>
                </el-select>
                <el-select
                    v-if="isTcrkModel"
                    v-model="tcrkShelfSpaceId"
                    :loading="loading"
                    filterable
                    clearable
                    reserve-keyword
                    remote
                    :remote-method="value => tcrkRemoteMethod(value, tcrkWarehouseId)"
                    @visible-change="
                        value => {
                            if (value && tcrkShelfSpaceOptions == 0) tcrkRemoteMethod('', tcrkWarehouseId);
                        }
                    "
                    size="small"
                >
                    <el-option v-for="item in tcrkShelfSpaceOptions" :key="item.ShelfSpaceId" :label="item.ShelfSpaceCode" :value="item.ShelfSpaceId"> </el-option>
                </el-select>
            </div>
            <div v-if="isTcrkModel">
                <el-button size="small" @click="isTcrkModel = false">取消</el-button>
                <el-button class="btn-primary" size="small" @click="tcrkSubmitData">入仓</el-button>
            </div>
        </div>
        <div class="tips">整单商品入库到同一仓位下</div>
        <div class="warehouseOut-main">
            <div class="div-table-row table-title">
                <div class="div-table-cell" style="width: 15%">配件名称</div>
                <div class="div-table-cell" style="width: 15%">配件编码</div>
                <div class="div-table-cell" style="width: 10%">待入仓数</div>
                <div class="div-table-cell flex" style="width: 60%">
                    <div class="border-right cell-item" style="width: 30%">仓库</div>
                    <div class="border-right cell-item" style="width: 30%">仓位</div>
                    <div class="border-right cell-item" style="width: 20%">数量</div>
                    <div class="cell-item" style="width: 20%"></div>
                </div>
            </div>
            <div class="table-main">
                <div class="div-table-row" v-for="(goods, index) in dataList" :key="goods.EntpTempGoodsId">
                    <div class="div-table-cell" style="width: 15%">
                        {{ goods.GoodName }}
                    </div>
                    <div class="div-table-cell" style="width: 15%">
                        {{ goods.APCode }}
                    </div>
                    <div class="div-table-cell" style="width: 10%">
                        {{ goods.Count }}
                    </div>
                    <div class="div-table-cell" style="width: 60%">
                        <!--循环仓库、仓位-->
                        <div class="cell-line" v-for="(shelfSpace, i) in goods.GoodsLocationList" :key="i.key">
                            <div class="border-right cell-item" style="width: 30%">
                                <el-select
                                    v-model="shelfSpace.WarehouseId"
                                    size="small"
                                    filterable
                                    clearable
                                    @change="warehouseChange($event, goods, shelfSpace)"
                                    :disabled="isTcrkModel"
                                >
                                    <el-option v-for="optionItem in WarehouseList" :label="optionItem.WarehouseName" :value="optionItem.WarehouseId" :key="optionItem.WarehouseId">
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="border-right cell-item" style="width: 30%">
                                <span style="color: #409eff" v-if="goods.searching">推荐中 <i class="el-icon-loading"></i></span>
                                <el-select
                                    v-else
                                    v-model="shelfSpace.ShelfSpaceId"
                                    filterable
                                    clearable
                                    reserve-keyword
                                    remote
                                    :remote-method="val => remoteMethod(val, goods.EntpTempGoodsId)"
                                    v-select-scroll-more="remoteMethodScrollMore"
                                    @change="positionChange($event, goods, shelfSpace)"
                                    @visible-change="positionVisibleChange($event, shelfSpace.WarehouseId, shelfSpace, goods.EntpTempGoodsId)"
                                    size="small"
                                    :disabled="isTcrkModel"
                                    @focus="shelfSpaceFocus(index, i, shelfSpace, goods)"
                                >
                                    <el-option
                                        v-for="optionItem in shelfSpace.ShelfSpacesList"
                                        :key="optionItem.ShelfSpaceId"
                                        :label="optionItem.ShelfSpaceCode"
                                        :value="optionItem.ShelfSpaceId"
                                    >
                                        <span style="display: inline-block; width: 150px">{{ optionItem.ShelfSpaceCode }}</span>
                                        <span v-if="!isNaN(optionItem.Count)">库存:{{ optionItem.Count }}</span>
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="border-right cell-item" style="width: 20%">
                                <el-input size="small" type="number" v-model="shelfSpace.Count" min="0"> </el-input>
                            </div>
                            <div class="cell-item ops-ctn" style="width: 20%; height: 28px; margin-top: 7px">
                                <el-button size="mini" icon="el-icon-minus" @click="delItem(index, i)" :disabled="isTcrkModel"></el-button>
                            </div>
                        </div>
                    </div>
                    <el-button size="mini" icon="el-icon-plus" class="add-btn ops-btn" @click="addItem(index)" :disabled="isTcrkModel"></el-button>
                </div>
            </div>
        </div>
        <div class="dialog-footer" v-if="!isTcrkModel">
            <el-button size="small" @click="cancel">取消</el-button>
            <el-button class="btn-primary" size="small" @click="submitData">入仓</el-button>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    props: ['PTOId'],
    components: {},
    data() {
        return {
            loading: false,
            dailogLoading: true,
            searchPositionReq: {
                WarehouseId: '',
                ShelfSpaceCode: '',
                GoodsId: '',
                SortField: 'Count',
                SortType: 'asc',
                MustIn: false,
                Page: 1,
                Limit: 10
            },
            formData: {
                TOId: this.PTOId,
                GoodsList: [
                    {
                        EntpTempGoodsId: '',
                        Count: 0,
                        GoodsLocationList: [
                            {
                                ShelfSpaceId: '',
                                Count: ''
                            }
                        ]
                    }
                ]
            },
            WarehouseList: [],
            dataList: [],
            isTcrkModel: false, // 是否开启同仓入库模式
            tcrkWarehouseId: '', // 同仓入库仓库信息
            tcrkShelfSpaceId: '', // 同仓入库仓位信息
            tcrkShelfSpaceOptions: [], // 同仓入库仓位列表
            firstIndex: 0, // goodsList 的下标
            secoundIndex: 0, // goodsList[firstIndex].GoodsLocationList 的下标
            currentShelfSpaceObj: {}, // 当前的下拉框仓位数据
            getLatelySpace: false //是否获取商品最近在当前仓库下存放的仓位
        };
    },
    mounted() {
        this.getWarehouse();
        this.getTODetail();
    },
    methods: {
        checkCount(count, max) {
            if (count > max) {
                this.$util.warningMsg('数量不得大于库存数量');
            }
        },
        cancel() {
            this.$emit('closeDialog');
        },
        submitData() {
            let _data = this.dataList;
            if (_data.length == 0) {
                this.$util.warningMsg('无可入仓商品，请确认后重新操作');
                return;
            }
            for (let i = 0; i < _data.length; i++) {
                let PV = _data[i].Count;
                let EV = 0;
                for (let j = 0; j < _data[i].GoodsLocationList.length; j++) {
                    if (!_data[i].GoodsLocationList[j].ShelfSpaceId) {
                        this.$util.warningMsg('请选择仓位');
                        return;
                    }
                    if(_data[i].GoodsLocationList[j].Count<=0){
                         this.$util.warningMsg('入仓数量必须大于零');
                        return;
                    }
                    if (_data[i].GoodsLocationList[j].Count > _data[i].GoodsLocationList[j].CountMax) {
                        this.$util.warningMsg('数量不得大于库存数量');
                        return;
                    }
                    EV += Number(_data[i].GoodsLocationList[j].Count);
                }
                if (PV != EV) {
                    this.$util.warningMsg('入库数量与待入库数量填写不相等');
                    return;
                }
            }
            this.dailogLoading = true;
            this.formData.GoodsList = this.dataList;
            this.$util
                .axiosPost({
                    url: '/api/EntpTransferOrder/SubmitProcessTransOrderIn',
                    data: this.formData
                })
                .then(res => {
                    if (res.errcode == 0) {
                        this.$util.successMsg(res.errmsg);
                        this.$store.commit('updateNeedRefresh', true);
                        this.$emit('closeDialog', true);
                    } else this.$util.errorMsg(res.errmsg);
                })
                .catch(() => {
                    this.dailogLoading = false;
                });
        },
        //仓位下拉框出现/隐藏时触发
        positionVisibleChange(val, warehouseId, warehouse, goodsId) {
            if (!val || !warehouseId) return;
            let that = this;
            if (!(warehouse.ShelfSpacesList && warehouse.ShelfSpacesList.length > 0)) {
                that.searchPositionReq.WarehouseId = warehouseId;
                that.searchPositionReq.ShelfSpaceCode = '';
                that.searchPositionReq.GoodsId = goodsId;
                that.searchPositionReq.Page = 1;
                that.searchPosition(that.searchPositionReq).then(resp => {
                    let newArr = [];
                    if (resp.data) newArr = resp.data;
                    that.$set(warehouse, 'ShelfSpacesList', newArr);
                    that.loading = false;
                });
            }
        },
        remoteMethod(val, warehouseId, warehouse, goodsId) {
            if (!val || !warehouseId) return;
            let that = this;
            that.searchPositionReq.WarehouseId = warehouseId;
            that.searchPositionReq.ShelfSpaceCode = val;
            that.searchPositionReq.GoodsId = goodsId;
            that.searchPositionReq.Page = 1;
            that.searchPosition(that.searchPositionReq).then(resp => {
                let newArr = [];
                if (resp.data) newArr = resp.data;
                that.$set(warehouse, 'ShelfSpacesList', newArr);
                that.loading = false;
            });
        },
        // 搜仓位
        searchPosition(req) {
            let that = this;
            if (!req.WarehouseId || that.loading) return;
            that.loading = true;
            return that.$util.getPositionByGId(that.searchPositionReq);
        },
        // positionChange(value, index, i) {
        //     let flag = 0;
        //     let _data = { ...this.dataList[index] };
        //     let target = _data.GoodsLocationList[i].ShelfSpacesList ? _data.GoodsLocationList[i].ShelfSpacesList : [];
        //     for (let j = 0; j < _data.GoodsLocationList.length; j++) {
        //         if (_data.GoodsLocationList[j].ShelfSpaceId == value) {
        //             flag += 1;
        //             if (flag >= 2) {
        //                 _data.GoodsLocationList[j].ShelfSpaceId = '';
        //                 this.$util.warningMsg('不能选相同仓位');
        //                 return;
        //             }
        //         }
        //     }
        //     this.$set(this.dataList, index, _data);
        // },
        positionChange(value, goods, shelfSpace) {
            if (!value) return;
            let that = this;
            let flag = 0;
            goods.GoodsLocationList.forEach(e => {
                if (e.ShelfSpaceId == value) {
                    flag++;
                    if (flag > 1) {
                        shelfSpace.ShelfSpaceId = '';
                        that.$util.warningMsg('同个商品不能选相同仓位');
                        return;
                    }
                }
            });
        },
        delItem(index, i) {
            let _data = { ...this.dataList[index] };
            if (_data.GoodsLocationList.length != 1) {
                _data.GoodsLocationList.splice(i, 1);
            }
            this.$set(this.dataList, index, _data);
        },
        addItem(index) {
            let _target = this.dataList[index].GoodsLocationList;
            let usedCount = 0; //已选数量
            for (let i = 0; i < _target.length; i++) {
                if (!_target[i].ShelfSpaceId) {
                    this.$util.warningMsg('请选择仓位');
                    return;
                }
                if (!_target[i].Count || !_target[i].Count < 0) {
                    this.$util.warningMsg('请填写正确的数量');
                    return;
                }
                usedCount += Number(_target[i].Count);
            }
            let goods = { ...this.dataList[index] };
            //当前商品可入库数量
            let canInCount = Number(goods.Count);
            //剩余数量
            let surplus = canInCount - usedCount;
            goods.GoodsLocationList.push({
                WarehouseName: goods.WarehouseName,
                WarehouseId: goods.WarehouseId,
                ShelfSpaceCode: '',
                ShelfSpaceId: '',
                Count: surplus > 0 ? surplus : 0,
                CountMax: goods.Count,
                ShelfSpacesList: [...goods.GoodsLocationList[goods.GoodsLocationList.length - 1].ShelfSpacesList]
            });
            this.$set(this.dataList, index, goods);
        },
        getTODetail() {
            let that = this;
            this.$util
                .axiosGet({
                    url: '/api/EntpTransferOrder/GetProcessInContainWH',
                    data: {
                        PTOId: this.PTOId
                    },
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    let spaceItem = {
                        WarehouseName: '',
                        WarehouseId: '',
                        ShelfSpaceCode: '',
                        ShelfSpaceId: '',
                        Count: '',
                        CountMax: 999,
                        ShelfSpacesList: []
                    };
                    let _APList = [];
                    for (let i = 0; i < data.DetailList.length; i++) {
                        spaceItem.Count = data.DetailList[i].Count;
                        spaceItem.CountMax = data.DetailList[i].Count;
                        spaceItem.WarehouseId = data.DetailList[i].WarehouseId;
                        spaceItem.WarehouseName = data.DetailList[i].WarehouseName;
                        data.DetailList[i].GoodsLocationList = [{ ...spaceItem }];
                        _APList.push(data.DetailList[i]);
                    }

                    if (data.warehouseId) {
                        for (let i = 0; i < that.WarehouseList.length; i++) {
                            if (that.WarehouseList[i].WarehouseId == data.WarehouseId) {
                                spaceItem.ShelfSpacesList = that.WarehouseList[i].ShelfSpaces;
                                spaceItem.WarehouseId = data.WarehouseId;
                                break;
                            }
                        }
                    }
                    this.dataList = _APList;
                    this.dailogLoading = false;
                });
        },
        // 获取仓库列表
        getWarehouse() {
            this.$util.getWarehouse().then(data => {
                this.WarehouseList = data;
                this.$util.getSysConfig('cgrczjcw').then(data => {
                    this.getLatelySpace = data && data.Result;
                });
            });
        },
        // 仓位下拉框滚动加载
        remoteMethodScrollMore() {
            this.remoteMethod();
        },
        shelfSpaceFocus(x, y, obj, goods) {
            this.firstIndex = x;
            this.secoundIndex = y;
            this.currentShelfSpaceObj = obj;
            this.currentShelfSpaceObj.GoodsId = goods.EntpTempGoodsId;
        },
        warehouseChange(value, goods, shelfSpace) {
            shelfSpace.ShelfSpacesList = [];
            shelfSpace.ShelfSpaceId = '';
        },
        tcrkRemoteMethod(value, tcrkWarehouseId) {
            if (!tcrkWarehouseId) return;
            let that = this;
            that.loading = true;
            that.$util
                .GetShelfSpacesList({
                    WarehouseId: tcrkWarehouseId,
                    ShelfSpaceCode: value,
                    Limit: 20,
                    IsLimit: true,
                    IncludecWaste: false
                })
                .then(res => {
                    that.loading = false;
                    if (res.data) {
                        that.tcrkShelfSpaceOptions = res.data;
                    } else {
                        that.$util.warningMsg('该仓库暂无仓位');
                    }
                })
                .catch(error => {
                    that.loading = false;
                });
        },
        tcrkSubmitData() {
            if (!this.tcrkWarehouseId) {
                this.$util.warningMsg('请选择仓库');
                return;
            }
            if (!this.tcrkShelfSpaceId) {
                this.$util.warningMsg('请选择仓位');
                return;
            }
            let _data = this.dataList;
            _data.forEach(i1 => {
                i1.GoodsLocationList.forEach(i2 => {
                    i2.WarehouseId = this.tcrkWarehouseId;
                    i2.ShelfSpaceId = this.tcrkShelfSpaceId;
                    i2.ShelfSpacesList = this.tcrkShelfSpaceOptions;
                });
            });
            this.formData.GoodsList = _data;
            this.submitData();
        }
    }
};
</script>
<style lang="less" scoped>
.dialog-header {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.tips {
    color: #f00;
    margin-top: 4px;
    margin-left: 4px;
}
.add-btn {
    position: absolute;
    right: 10px;
    bottom: 6px;
}
.ops-ctn {
    text-align: left !important;
}
.dialog-footer {
    text-align: right;
}
.warehouseOut {
    padding-bottom: 20px;
}
.warehouseOut-main {
    padding-top: 20px;
}
.table-title {
    .cell-item {
        width: 33.33%;
    }
    .div-table-cell {
        text-align: center;
        height: 30px;
        line-height: 30px;
    }
}
.div-table-row {
    position: relative;
    overflow: visible;
}
.table-main {
    .div-table-cell {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
    }
    .cell-line {
        display: flex;
        width: 100%;
    }
    .cell-item {
        padding: 0 10px;
        width: 33%;
        width: inherit;
        text-align: center;
        height: 40px;
        line-height: 40px;
    }
}
</style>
